import { render, staticRenderFns } from "./MessageLikesItem.vue?vue&type=template&id=1c30587a&scoped=true&"
import script from "./MessageLikesItem.vue?vue&type=script&lang=js&"
export * from "./MessageLikesItem.vue?vue&type=script&lang=js&"
import style0 from "./MessageLikesItem.vue?vue&type=style&index=0&id=1c30587a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c30587a",
  null
  
)

export default component.exports